export default {
  WarningFormula: 'Kiểm tra lại phát sinh và công thức. Xem hướng dẫn <a {0}>tại đây</a>.',
};
